import type { ReportItem, ReportQueueResponse } from '@bunker/shared';

/**
 * `?mock=full`: a moderation queue with one report in each state that looks
 * different on screen (open, in review with an escalation, closed), so the
 * «Жалобы» tab can be designed and checked without a backend. Unhandled, the
 * route fell through to the generic `{ ok: true }` and the tab crashed
 * (BNK-A0463029, found by Codex in the design pass).
 */
const T = Date.UTC(2026, 8, 26, 18, 0);
const at = (minutes: number) => new Date(T + minutes * 60_000).toISOString();
const user = (id: string, username: string, displayName: string) => ({ id, username, displayName, avatarUrl: null });

const REPORTS: ReportItem[] = [
  {
    id: 'rep_mock_open', kind: 'message', scope: 'guild', reason: 'spam', note: 'Одинаковое сообщение в трёх каналах подряд',
    status: 'open', platformEscalated: false,
    snapshot: { content: 'Бесплатные скины по ссылке, успей первым!!!', author: { username: 'skinbot', displayName: 'Раздача скинов' } },
    resolution: null, createdAt: at(12), resolvedAt: null,
    guildId: 'g_cispracs', channelId: 'c_general', messageId: 'm_mock_spam',
    reporter: user('u_kostyl', 'kostyl', 'Костыль'), targetUser: user('u_skinbot', 'skinbot', 'Раздача скинов'),
    reviewer: null, guild: { id: 'g_cispracs', name: 'cispracs · core' },
  },
  {
    id: 'rep_mock_reviewing', kind: 'user', scope: 'guild', reason: 'harassment', note: null,
    status: 'reviewing', platformEscalated: true, snapshot: null,
    resolution: null, createdAt: at(-90), resolvedAt: null,
    guildId: 'g_cispracs', channelId: null, messageId: null,
    reporter: user('u_b1ad', 'b1ad', 'b1ad'), targetUser: user('u_toxic', 'toxic', 'toxic'),
    reviewer: user('me_0', 'tester', 'Тестер'), guild: { id: 'g_cispracs', name: 'cispracs · core' },
  },
  {
    id: 'rep_mock_closed', kind: 'message', scope: 'guild', reason: 'other', note: 'Оффтоп в канале турнира',
    status: 'dismissed', platformEscalated: false,
    snapshot: { content: 'кто на мид сегодня?', author: { username: 'maks', displayName: 'maks' } },
    resolution: 'Не нарушение', createdAt: at(-1440), resolvedAt: at(-1400),
    guildId: 'g_cispracs', channelId: 'c_praks', messageId: 'm_mock_offtopic',
    reporter: user('u_dominik', 'dominik', 'Доминик'), targetUser: user('u_maks', 'maks', 'maks'),
    reviewer: user('me_0', 'tester', 'Тестер'), guild: { id: 'g_cispracs', name: 'cispracs · core' },
  },
];

/** The mock answer for `GET /api/reports`, filtered like the server filters. */
export function mockReportQueue(search: URLSearchParams): ReportQueueResponse {
  const status = search.get('status');
  const guildId = search.get('guildId');
  const reports = REPORTS.filter((r) => (!status || r.status === status) && (!guildId || r.guildId === guildId));
  return { reports, nextCursor: null };
}
